<template>
  <portlet
    :icon="'fad fa-mobile'"
    :title="name"
    :actionsBlock="true"
  >
    <template slot="portletBody">
      <div class="category-container row" style="margin-bottom: 1.5rem">
        <div class="col-12">
            <section-menu 
                :menu="menu" 
                :entry="menuEntry"
                @entryClick="menuClick($event)"
                >
            </section-menu>
        </div>
      </div>
      <hr/>
      
      
      <div class="documents-container row">
        <div class="col-12">
          <component v-bind:is="currentComponent" :organization="id" :customer="overtimeCustomer" ref="curComp"></component>
        </div>
      </div>
      
    </template>
  </portlet>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {dataTables} from '../../components/mixins/dataTables.js';
  import {swalModals} from '../../components/mixins/swalModals.js';
  import Vue from 'vue';
  import store from '../../store.js';
  import document from '../../components/documents/document.vue';
  import { Can } from '../../../permission/ability.js';
  import uploadDocument from '../../components/documents/uploadDocument.vue'
  import sectionMenu from '../../components/documents/sectionMenu.vue'
  import employments from '../../store/employments/employments.js';
  import hourSettings from '../../components/configuration/hourSettings.vue';
  import metrics from '../../components/configuration/metrics.vue';
  import customerOvertimeSettings from '../../components/customer/customerOvertimeSettings.vue';
  import { RIGHTS } from '../roles/rights';
  
  export default {
  components: { document, uploadDocument, sectionMenu, hourSettings, customerOvertimeSettings },
    mixins: [dataTables, swalModals],
    data() {
      return {
        rights: {},
        id: null,
        name: '',
        isAdmin: false,
        organization: null,
        menuEntry: null,
        menu: [{name: 'Hour Settings', id: 1, right: 'CONFIG_EDIT'}, {name: 'Dienst overzicht', id: 2, right: 'CONFIG_VIEW'}/*, {name: 'Metrics', id: 4}*/],
        currentComponent: null,
        overtimeCustomer: null
      };
    },
  async   created() {
      this.rights = RIGHTS;
      this.$store.commit('setLoading',true)
      this.id = parseInt(this.$route.params.id)
      this.name = this.$route.params.name
      await  this.fetchData();
      this.menuEntry = Can(this.menu[0].right) ? {id: 1} : {id: 2}
      this.$store.commit('setLoading',false)
      this.isAdmin = this.$store.state.users.me.admin;
    },
    methods: {
      Can,
      async  fetchData() {
        this.$store.commit('setLoading',true)
        store.dispatch('users/getMyUserHourApp', {
            ApiClient:   Vue.prototype.$ApiClient,
            departments: store.getters.getUserData.departments
        });
        
        await store.dispatch('organizations/get', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, company_id: this.id}).then((res) => {
          if (res.status === 200) {
            this.organization = res.data.data
          }
        }).catch((err) => {
            console.log(err)
            alert('Unexpected error downloading organizations')
        });
        
        this.$store.commit('setLoading',false)
      },
      setFile(e) {
        if(e.target.files && e.target.files.length > 0) {
            this.file = e.target.files[0]
        } else {
            this.file = null
        }
        
      },
      menuClick(event) {
        this.menuEntry = event
      },
      uploadFile(event) {
        console.log(event)
        store.dispatch('documents/createDocument', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, file: this.file, documentCategoryId: event.category, employmentId: this.id}).then((res) => {
            
            if (res.status === 201) {
                this.$swal({
                    title: "Success!",
                    html: 'The document has been published correctly',
                    type: "info",
                    confirmButtonText: 'Oké',
                    reverseButtons: true,
                }).then(() => {
                    this.fetchData()
                })
            }
        }).catch((err) => {
            console.log(err)
            alert('Unexpected error uploading the document')
        });
      },
      getYear(document) {
        return moment(document.created_at, 'YYYY-MM-DD').year()
      },
      yearClick(year) {
        this.year = year
      },
      getYearClass(year) {
        return year === this.year ? 'year-widget active' : 'year-widget'
      },
      categoryClick(category) {
        this.category = category.id
      },
      getCategoryClass(category) {
        return category.id === this.category ? 'sub-category-widget active' : 'sub-category-widget'
      },
      getCategory(document) {
        return document.category.id
      },
      documentsOfYearAndCategory() {
        // Filter documents of the current year and category
        let t = this.documents.filter((doc, key) => {
            if(this.year === this.getYear(doc) && this.category === this.getCategory(doc) && doc.file !== null) {
                return doc;
            }
        })
        return t
      }
    },
    computed: {
      ...mapGetters('roles', ['getRoles']),
      ...mapGetters('employments', [
          'getEmployment'
        ])
    },
    watch: {
        menuEntry(newV, oldV) {
            if(newV !== null) {
                switch(newV.id) {
                    case -1:
                        this.$router.push('/configurations')
                    break;
                    case 1:
                        this.currentComponent = hourSettings
                    break;
                    case 2:
                        if (!this.organization || !this.organization.firebaseId) {
                            this.$toasted.global.failedRequest({
                                message: 'Geen gekoppelde klant gevonden voor deze organisatie.'
                            })
                            break
                        }

                        this.overtimeCustomer = null
                        this.currentComponent = null
                        this.$store.commit('setLoading', true)
                        this.$store.dispatch('customers/fetchById', this.organization.firebaseId).then((res) => {
                            this.overtimeCustomer = Object.assign({}, res)
                            this.currentComponent = customerOvertimeSettings
                        }).catch(() => {
                            this.$toasted.global.failedRequest({
                                message: 'Klantgegevens konden niet worden geladen.'
                            })
                        }).finally(() => {
                            this.$store.commit('setLoading', false)
                        })
                    break;
                    case 4:
                        this.currentComponent = metrics
                    break;
                }
            }
        }
    }
  };
</script>

<style lang="scss">
    @import "../../components/configuration/assets/configuration.scss";
</style>
